import styles from './button.module.scss';
import device from 'current-device';
import { Subscription } from '../../observer.model';
import { WideWidgetStyle } from '../wide/wide-widget-style';
import { Dentolo } from '../../../dentolo';
import EventEmitter from '../../event-emitter.model';

export default class Button {
	constructor(text:string, className:WideWidgetStyle='default', mobileOptions?:Dentolo.WideButtonOnMobilesOptions, buttonShadow?: string) {
		this.element.textContent = text;
		this.element.className = styles[className];
		this.element.dataset.nameSpace = 'dentolo';

		this.element.onclick = (e) => {
			this.eventEmitter.emit("click", e);
		}

    
		if (device.mobile()) {
      if (mobileOptions?.align == 'left') this.element.style.margin = "0";
			if (mobileOptions?.align == 'right') this.element.style.float = "right";
			if (mobileOptions?.width) this.element.style.maxWidth = mobileOptions.width;
			if (mobileOptions?.text) this.element.textContent = mobileOptions.text;
		}
    if (buttonShadow) this.element.style.boxShadow = buttonShadow;
	}

	public element:HTMLButtonElement = document.createElement('button');
	private eventEmitter = new EventEmitter();

	public onClick(callback:(event:MouseEvent)=>void):Subscription {
		return this.eventEmitter.subscribe("click", callback);
	}
}